import useSWR from 'swr'

export const CUSTOMER_COMPANY_TYPE = 1
export const CUSTOMER_INDIVIDUAL_TYPE = 0

export type CustomerTypes =
  | typeof CUSTOMER_COMPANY_TYPE
  | typeof CUSTOMER_INDIVIDUAL_TYPE

export interface GetCustomerResourceResponse {
  country: string
  name: string
  tax_identifier: string
  street: string
  postal_code: string
  city: string
  is_company: CustomerTypes
}

export const useGetCustomerResource = () =>
  useSWR<GetCustomerResourceResponse>('v1/payments/customers')
